// extracted by mini-css-extract-plugin
export default {"error-message-box":"DatePicker_error-message-box__IXCU7"};